import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { CartProvider, AuthProvider } from "./lib/store";
import { http, EXTRA_GROUPS, OTHER_GROUPS } from "./lib/api";
import { dutchInvalid, clearDutchValidity } from "./lib/api";

import Header from "./components/Header";
import Footer, { CookieBanner } from "./components/Footer";
import Home from "./pages/Home";
import Category, { Brands } from "./pages/Category";
import FloorGuide from "./pages/FloorGuide";
import Product from "./pages/Product";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import PaymentReturn from "./pages/PaymentReturn";
import ReviewPage from "./pages/Review";
import { InfoPage, Account } from "./pages/Info";
import Admin from "./pages/Admin";

function Shell() {
  const loc = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  useEffect(() => {
    document.documentElement.lang = 'nl';
    document.addEventListener('invalid', dutchInvalid, true);
    document.addEventListener('input', clearDutchValidity, true);
    document.addEventListener('change', clearDutchValidity, true);
    return () => { document.removeEventListener('invalid', dutchInvalid, true); document.removeEventListener('input', clearDutchValidity, true); document.removeEventListener('change', clearDutchValidity, true); };
  }, []);
  useEffect(() => { http.get("/site").then((r) => {
    window.__VL_NOINDEX = !!r.data.noindex;
    const d = (r.data.company?.domain || "").trim().replace(/\/$/, "");
    if (d) window.__VL_ORIGIN = d.startsWith("http") ? d : `https://${d}`;
    if (!r.data.noindex && !window.__VL_PAGE_NOINDEX) document.head.querySelector('meta[name="robots"]')?.setAttribute("content", "index, follow");
  }).catch(() => {}); }, []);
  if (loc.pathname.startsWith("/beheer")) return <Routes><Route path="/beheer/*" element={<Admin />} /></Routes>;
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" data-testid="skip-to-content" onClick={() => document.getElementById('main-content')?.focus()} className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-[#272D30] focus:text-white focus:px-5 focus:py-3 focus:rounded-lg">Direct naar de inhoud</a>
      <Header />
      <main id="main-content" tabIndex={-1} data-testid="main-content" className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pvc" element={<Category />} />
          <Route path="/laminaat" element={<Category />} />
          <Route path="/ondervloeren" element={<Category />} />
          <Route path="/plinten" element={<Category />} />
          <Route path="/profielen" element={<Category />} />
          {[...EXTRA_GROUPS, ...OTHER_GROUPS].map((g) => <Route key={g[0]} path={g[1]} element={<Category />} />)}
          <Route path="/keuzehulp-vloeropbouw" element={<FloorGuide />} />
          <Route path="/zoeken" element={<Category />} />
          <Route path="/merken" element={<Brands />} />
          <Route path="/merken/:brand" element={<Category />} />
          <Route path="/product/:slug" element={<Product />} />
          <Route path="/winkelwagen" element={<Cart />} />
          <Route path="/afrekenen" element={<Checkout />} />
          <Route path="/betaling/:id" element={<PaymentReturn />} />
          <Route path="/bestelling/:id" element={<PaymentReturn statusOnly />} />
          <Route path="/review/:orderId" element={<ReviewPage />} />
          <Route path="/info/:slug" element={<InfoPage />} />
          <Route path="/account" element={<Account />} />
          <Route path="*" element={<div className="p-24 text-center font-serif-brand text-3xl">Pagina niet gevonden</div>} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter><Shell /></BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </AuthProvider>
  );
}
